export class CustomerSurveyAnswer {
  answer: any;
  comment: string;
}
